import { createMuiTheme } from "@material-ui/core/styles";

export const MaterialUITheme = createMuiTheme({
  palette: {
    secondary: {
      main: "#f09440",
    },
  },
});
